import { Box, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { formatMoney, getPercentage } from 'helpers';
import { useMemo } from 'react';
import Info from '../Info/Info';
import { Container } from './Badge.styled';

export default function Badge({ hide, highlight, info, label, responsive, tabIndex, title, type, value }: BadgeProps) {
    const val = useMemo(() => {
        if (isNaN(value)) {
            return '-';
        } else if (type === 'currency') {
            return '$' + formatMoney(value);
        } else if (type === 'percentage') {
            return getPercentage(value);
        }
    }, [type, value]);

    return (
        <Container $hide={hide} $highlight={highlight} $responsive={responsive}>
            <Typography aria-hidden variant="montserrat514">
                {label}:
            </Typography>
            <Box whiteSpace="nowrap">
                <Box component="span" role="status">
                    <Typography component="span" sx={visuallyHidden}>
                        {title || label}:&nbsp;
                    </Typography>
                    <Typography variant="montserrat714">{val}</Typography>
                </Box>
                {info && <Info name={info} tabIndex={tabIndex} />}
            </Box>
        </Container>
    );
}
